// extracted by mini-css-extract-plugin
export default {"title":"Cards_title__JL4HS","root":"Cards_root__Sd+-H"};